import React from "react";
import {FormModalProps} from "../../utils/useFormModal";
import {Checkbox, Form, Input, Modal, Select as AntSelect} from "antd";
import Select from "../../components/Select";


function ServiceModal(props: FormModalProps) {
    const {form, ...otherProps} = props

    function renderObject(label: string, name: string) {
        const typeLabel = label + '参与者'
        const typeName = ['params', name + '-type']
        const userLabel = label + '用户'
        const userName = ['params', name + '-user']
        const roleLabel = label + '角色'
        const roleName = ['params', name + '-role']
        return (
            <>
                <Form.Item name={typeName} label={typeLabel}
                           rules={[{required: true, message: '请选择' + typeLabel}]}>
                    <AntSelect onChange={() => form.setFieldsValue({
                        [userName[0]]: {
                            [userName[1]]: undefined,
                            [roleName[1]]: undefined,
                        }
                    })}>
                        <AntSelect.Option value={'role'}>角色</AntSelect.Option>
                        <AntSelect.Option value={'user'}>用户</AntSelect.Option>
                    </AntSelect>
                </Form.Item>
                <Form.Item noStyle dependencies={[typeName]}>
                    {({getFieldValue}) => {
                        const type = getFieldValue(typeName)
                        return (
                            <>
                                {type === 'role' && (
                                    <Form.Item name={roleName} label={roleLabel}
                                               rules={[{required: true, message: '请选择' + roleLabel}]}>
                                        <Select url={'/role/'} getData={data => data.data} textField={'name'}
                                                valueField={'id'} mode={"multiple"}/>
                                    </Form.Item>
                                )}
                                {type === 'user' && (
                                    <Form.Item name={userName} label={userLabel}
                                               rules={[{required: true, message: '请选择' + userLabel}]}>
                                        <Select url={'/user/'} getData={data => data.data} textField={'nickName'}
                                                valueField={'id'} mode={"multiple"}/>
                                    </Form.Item>
                                )}
                            </>
                        )
                    }}
                </Form.Item>
            </>
        )
    }

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={"vertical"}>
                {renderObject('工作流审批', 'approval-first')}
                {renderObject('加盟商审核', 'approval-second')}
                {renderObject('直营店审核', 'approval-second-directly')}
                {renderObject('消息知会', 'notify')}
                <Form.Item name={'color'} label={'消息字体颜色'}>
                    <Input type={'color'} style={{width: '100px'}}/>
                </Form.Item>
                <Form.Item name={'notify'} label={'是否邮件通知'} valuePropName={'checked'}>
                    <Checkbox/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ServiceModal